<template>

    <div>
        <div class="row">
            <h1 class="page-title col-md-8 col-sm-12">{{client.code}} ({{client.hash}})</h1>
            <div class="col-md-4 col-sm-12 btn-row"  v-if="!isPreviousDateSession">
                <mdc-button class="btn btn-link btn-info"
                            v-if="isBCBA || isCurator || (isTherapist && hasAssignedQuiz)" raised
                            :to="{name: 'quiz', params: {clientId: clientId }}">
                    <img src="../../../../assets/images/poll.svg" alt="" height="16">
                    {{'quiz.quiz' | trans}}
                </mdc-button>

                <span class="btn btn-link btn-info mdc-button mdc-button--raised mdc-ripple-upgraded disabled" v-if="isTherapist && !hasAssignedQuiz">
                     <img src="../../../../assets/images/poll.svg" alt="" height="16">
                    {{'quiz.quiz' | trans}}
                </span>
                <mdc-button class="btn btn-link btn-info" raised :to="{name: 'client-undesirable-behavior', params: {clientId: clientId } }">
                    <img src="../../../../assets/images/NP.svg" alt="">
                    {{'behavior.UB' | trans}}
                </mdc-button>
                <mdc-button class="btn btn-link btn-info" raised :to="{name: 'client-appeals', params: {clientId: clientId }}">
                    <img src="../../../../assets/images/P.svg" alt="">
                    {{'appeals.appeals' | trans}}
                </mdc-button>
            </div>
        </div>
        <div class="info-block mb-3">
            <div class="row">
                <div class="col-md-4">
                    <dl>
                        <dt>{{'user.clinical_center' | trans}}:</dt>
                        <dd>{{client.clinicalCenter ? client.clinicalCenter.name : ''}}</dd>
                        <dt>{{'user.contacts' | trans}}:</dt>
                        <dd>{{ client.displayName }}, {{ client.username }}</dd>
                    </dl>
                </div>
                <div class="col-md-4">
                    <dl>
                        <dt>{{'user.curator' | trans}}:</dt>
                        <dd v-for="curator in client.curators">
                            {{ curator.displayName }}
                        </dd>
                        <dt>{{'user.therapist' | trans}}:</dt>
                        <dd v-for="therapist in client.therapists">
                            {{ therapist.displayName }}
                        </dd>
                    </dl>
                </div>
                <div class="col-md-4">
                    <dl>
                        <dt>{{ 'user.hours_therapist' | trans}}:</dt>
                        <dd>{{ client.hoursWithTherapists ? client.hoursWithTherapists : 0 | asHours }}</dd>
                        <dt>{{ 'user.hours_parent' | trans}}:</dt>
                        <dd>{{ client.hoursWithParents ? client.hoursWithParents : 0 | asHours }}</dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  import axios from 'axios';
  import {mapGetters} from 'vuex';

  export default {
    name: 'ClientInfo',
    props: ['clientId'],
    data() {
      return {
        apiUrl: '/users/',
        client: {},
        hasAssignedQuiz: true
      };
    },

    async created() {
      this.getClient(this.clientId);

      if(this.isTherapist){
        this.getAssignedQuiz()
      }


    },

    computed: {
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
        'isTherapist',
        'isPreviousDateSession'
      ]),
    },
    methods: {

      getClient: async function (clientId) {
        try {
          let response = await axios.get(this.apiUrl + 'clients/' + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        }
      },
      getAssignedQuiz: async function () {
        try {
          let response = await axios.get(this.apiUrl + this.clientId + '/quiz/has-assigned-quiz');
          this.hasAssignedQuiz = !!response.data.data.hasAssignedQuiz;
        } catch (error) {
          console.dir(error)
        }
      },
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/user/client/components/ClientInfo.vue